if (!customElements.get("td-collection-column-selector")) {
  class TdCollectionColumnSelector extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeColumnButtons();
    }

    initializeColumnButtons() {
      this.productGrid = document.querySelector("#product-grid");

      if (!this.productGrid) {
        console.log("Product grid not found");
        return;
      }

      const isMobile = this.hasAttribute("data-columns-mb");
      const columnButtons = isMobile
        ? [
            { selector: "[data-column-2-mb]", className: "grid--2-col-tablet-down" },
            { selector: "[data-column-1-mb]", className: "grid--1-col-tablet-down" },
          ]
        : [
            { selector: "[data-column-2-dsk]", className: "grid--2-col-desktop" },
            { selector: "[data-column-4-dsk]", className: "grid--4-col-desktop" },
          ];

      columnButtons.forEach(({ selector, className }) => {
        const button = this.querySelector(selector);
        if (button) {
          button.addEventListener("click", () => this.setGridClass(className, columnButtons, button));
        }
      });

      this.setInitialState(columnButtons);
    }

    setGridClass(className, columnButtons, activeButton) {
      columnButtons.forEach(({ className }) => {
        this.productGrid.classList.remove(className);
      });

      // Add the new class to the grid
      this.productGrid.classList.add(className);

      // Remove the "is-active" class from all buttons
      columnButtons.forEach(({ selector }) => {
        const button = this.querySelector(selector);
        if (button) {
          button.classList.remove("td-column__is-active");
        }
      });

      // Add the "td-column__is-active" class to the clicked button
      activeButton.classList.add("td-column__is-active");
    }

    setInitialState(columnButtons) {
      const activeClass = columnButtons.find(({ className }) =>
        this.productGrid.classList.contains(className)
      );
      if (activeClass) {
        const activeButton = this.querySelector(activeClass.selector);
        if (activeButton) {
          activeButton.classList.add("td-column__is-active");
        }
      }
    }
  }

  customElements.define("td-collection-column-selector", TdCollectionColumnSelector);
}
